import React, { useState, useEffect, useMemo } from "react";
import { Box, Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useApolloClient } from "@apollo/client";
import { GET_EXTRA_BY_PERSONAL_ID } from "./QueryPersonal";
import LoopIcon from '@mui/icons-material/Loop';
const ViewExtra = ({ id, params }) => {
  const { setAlertCustom, alertCustom, handleCloseModal } = params;
  const client = useApolloClient();
  const [visibility, setvisibility] = useState(false);
  const [extraFicha, setextraFicha] = useState(null);
  useEffect(() => {
    const getextraFicha = async (id) => {
      try {
        const { data } = await client.query({
          query: GET_EXTRA_BY_PERSONAL_ID,
          variables: {
            getExtraByPersonalIdId: id,
          },
          fetchPolicy: "network-only",
        });     
        setextraFicha(data.getExtraByPersonalId);
        setvisibility(true);
      } catch (error) {
        setAlertCustom({
          ...alertCustom,
          type: "error",
          message: error.message,
          state: true,
        });
      }
    };
    getextraFicha(id);
  }, []);
  const style = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
  };
  return (
    visibility ? (
      <>
        {" "}
        <Box
          mt="20px"
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
          gap="20px"
        >
          <Box sx={style}>
            <label for="my-input">RUC</label>
            <TextField disabled value={extraFicha?.ruc} />
          </Box>
          <Box sx={style}>
            <label for="my-input">ESS</label>
            <TextField disabled value={extraFicha?.ess} />
          </Box>
          <Box sx={style}>
            <label for="my-input">CUSSPP</label>
            <TextField disabled value={extraFicha?.cusspp} />
          </Box>
          <Box sx={style}>
            <label for="my-input">TIPO</label>
            <TextField disabled value={extraFicha?.type?.description} />
          </Box>
          <Box sx={style}>
            <label for="my-input">FONDO DE PENSIONES</label>
            <TextField disabled value={extraFicha?.pensionfund?.description} />
          </Box>
        {/*   <Box sx={style}>
            <label for="my-input">FECHA</label>
            <TextField
              disabled
              value={new Date(extraFicha?.date).toLocaleDateString("es-ES")}
            />
          </Box> */}
        </Box>
        <Box display={"flex"} justifyContent={"end"} marginTop={"30px"}>
          <Button variant="contained" onClick={handleCloseModal}>
            CERRAR
          </Button>
          {/*  */}
        </Box>
      </>
    ):<Box sx={{display:"flex",justifyContent:"center"}}><LoopIcon/></Box>
  );
};

export default ViewExtra;
